import Page from 'components/modules/public/pages/PasswordReset';
export default Page;